import {SiteStore} from '@wix/wixstores-client-storefront-sdk';
import {ModalManager} from '@wix/wixstores-client-core';
import {ControllerParams} from '@wix/yoshi-flow-editor';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';
import {SPECS} from '../specs';

export class ModalManagerService {
  private readonly siteStore: SiteStore;
  public readonly modalManger: ModalManager;
  private readonly viewerContext: ViewerContext;

  constructor(
    {siteStore, viewerContext}: {siteStore: SiteStore; viewerContext: ViewerContext},
    private readonly controllerParams: ControllerParams
  ) {
    this.siteStore = siteStore;
    this.viewerContext = viewerContext;
    const moveCartToViewerContext = this.viewerContext.isExperimentEnabled(SPECS.MoveCartToViewerContext);
    this.modalManger = new ModalManager(
      {
        openModal: (url: string, width: number, height: number) => {
          return moveCartToViewerContext
            ? this.controllerParams.controllerConfig.wixCodeApi.window.openModal(
                url,
                {width, height, theme: 'BARE'},
                this.controllerParams.controllerConfig.compId
              )
            : this.siteStore.windowApis.openModal(
                url,
                {width, height, theme: 'BARE'},
                this.controllerParams.controllerConfig.compId
              );
        },
      },
      '//ecom.wix.com',
      moveCartToViewerContext
        ? this.viewerContext.getEcomPlatformInstance()
        : this.siteStore.instanceManager.getInstance()
    );
  }
}
